export const getEnv = () => {
    const env = document.head.querySelector("[property~=environment][content]").content;
    return env;
}

export const interceptor = () => {
    return function(config) {
        return $.get("/session/access_token").then(function(response){
            config.headers.Authorization = 'Bearer ' + response.access_token;
            return Promise.resolve(config);
        });
    }
}

export const creationSource = 'LOC_SCH_TV'